import { HerdCreate } from 'app/agriculture/routes/Herds/HerdCreate/HerdCreate';
import { HerdDelete } from 'app/agriculture/routes/Herds/HerdDelete/HerdDelete';
import { HerdDetails } from 'app/agriculture/routes/Herds/HerdDetails/HerdDetails';
import { HerdEdit } from 'app/agriculture/routes/Herds/HerdEdit/HerdEdit';
import { HerdList } from 'app/agriculture/routes/Herds/HerdList/HerdList';
import { RouteConfig } from 'app/agriculture/router/types';

export const herdsRouteConfig: RouteConfig = {
    rootPath: 'herds',
    routeElements: {
        Create: { Component: HerdCreate },
        Delete: { Component: HerdDelete },
        Details: { Component: HerdDetails },
        Edit: { Component: HerdEdit },
        List: { Component: HerdList },
    },
};
